// routes/_app.profile.edit.safety.tsx
import { dynamic } from 'src/utils/ssr'

const getClientModule = () => import('src/clientRoutes/_app.profile.edit.safety')

export const handle = {
  name: 'profile/edit/safety',
  track: { scene: 'profile-edit', section: 'content' },
}

export default dynamic(getClientModule, { ssr: false })
